import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { slugify } from '@/helpers'
import VueCookie from 'vue-cookie'
import DomPortal from 'vue-dom-portal'
import VueMq from 'vue-mq'


Vue.config.productionTip = false

Vue.filter('slugify', slugify)
Vue.use(DomPortal)
Vue.use(VueCookie)
Vue.use(VueMq, {
    breakpoints: {
      sm: 960,
      md: 1264,
      lg: 1300,
      xl: 1440,
      all: Infinity,
    }
  })
  

new Vue({
    data: {
        render_keys: {
            home: Date.now(),
        },
        got_game:false,
        game_info:{
            links: {
                boxscore:{
                    url:false
                },
                postgame: {
                    url:'https://lsusports.net/news/2020/1/13/lsu-football-national-championship-game-recap.aspx',
                    story_image_url:require('./assets/celebrate.jpg'),
                    text:'LSU Football National Championship Game Recap'
                }
            },
            results:[
                {
                    team_score:42,
                    opponent_score:25
                }
            ]
        },
        s3_path: 'https://s3.amazonaws.com/lsusports.net/cfp2020'
    },
    router,
    render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    if(!nearestWithMeta) return next();
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
    .forEach(tag => document.head.appendChild(tag));

    next();
});


router.afterEach((to) => {
    window.gtag('config', 'UA-148334355-4', {
        'page_path':  `/cfp2020${to.path}`
    });
});